"use client";

import Image from "next/image";
import EditSvg from "../Svg/EditSvg";
import { motion } from "framer-motion";
// import Dropdown from "@/components/Dropdown";
import { TeamSelect } from "@/types/team";
import { FaCheck } from "react-icons/fa6";
import { Dropdown, DropdownItem } from "flowbite-react";
import { FiChevronDown } from "react-icons/fi";
import { useRef } from "react";
import clsx from "clsx";
import { teamSelect } from "@/constants/team";
import Button from "@/components/Button";

interface ModalEditProfileProps {
  handleSave: () => void;
  handleFileClick: () => void;
  handleNameChange: (e: any) => void;
  handleBioChange: (e: any) => void;
  handleFileChange: (e: any) => void;
  handleTeamChange: (team: TeamSelect) => void;
  setFileName: (fileName: string) => void;
  isSubmitting: boolean;
  errorMessage: string | undefined;
  name: string;
  bio: string;
  team: string | undefined;
  fileName: string;
  hiddenFileInput: any;
  buttonText: string;
  isTeam: boolean;
  setIsTeam: (isTeam: boolean) => void;
  // shouldValidate?: string;
  // setShouldValidate: (shouldValidate: string) => void;
}

export default function ModalEditProfile({
  handleSave,
  handleFileClick,
  handleNameChange,
  handleBioChange,
  handleFileChange,
  handleTeamChange,
  isSubmitting,
  errorMessage,
  name,
  bio,
  team,
  fileName,
  hiddenFileInput,
  buttonText,
  isTeam,
  setIsTeam,
}: // shouldValidate,
// setShouldValidate,
ModalEditProfileProps) {
  const container = {
    hidden: { opacity: 0, scale: 0.8 },
    show: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.1,
        ease: [0, 0.71, 0.2, 1.01],
        scale: {
          // type: "spring",
          damping: 5,
          stiffness: 100,
          restDelta: 0.001,
        },
      },
    },
  };

  return (
    <>
      <div className="flex flex-col gap-3 w-full">
        <div className="grid gap-3 w-full mx-auto">
          <div className="flex flex-col md:flex-row gap-3 md:gap-7">
            <label className="w-full max-w-full md:max-w-28 font-poppins text-bitzy-white">
              Profile photo
            </label>

            <div className="flex flex-col gap-1">
              <div
                onClick={handleFileClick}
                className="relative w-max mx-auto md:mx-0 cursor-pointer"
              >
                <div className=" text-bitzy-white focus:outline-none w-[70px] h-[70px] flex flex-col justify-center items-center">
                  <div className="w-full h-full overflow-hidden rounded-full border border-bitzy-white relative">
                    <Image
                      src={fileName ? fileName : "/images/bitzy.png"}
                      fill
                      sizes={"width: 100%"}
                      style={{ objectFit: "cover" }}
                      alt="Bitzy"
                    />
                  </div>
                  <input
                    type="file"
                    onChange={handleFileChange}
                    ref={hiddenFileInput}
                    style={{ display: "none" }}
                    className="focus:ring-0 focus:outline-none"
                  />
                </div>

                <div className="w-6 h-6 bg-bitzy-meme-black/50 flex items-center justify-center rounded-lg absolute top-[-5px] right-[-5px] z-10">
                  <EditSvg className="w-4 h-4 fill-transparent stroke-bitzy-white" />
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[112px_auto] gap-3 md:gap-7">
            <label className="w-full max-w-full md:max-w-28 font-poppins text-bitzy-white">
              Username
            </label>

            <input
              type="text"
              value={name}
              onChange={handleNameChange}
              className="border border-bitzy-v2-gray/100/25 rounded-lg text-bitzy-v2-white placeholder:text-bitzy-v2-white/200 p-2 bg-bitzy-v2-white/25 focus:ring-0 focus:outline-none focus:border-bitzy-white/50 w-full h-9"
            />
          </div>

          <div className="flex flex-col md:flex-row gap-3 md:gap-7">
            <label className="w-full max-w-full md:max-w-28 font-poppins text-bitzy-white">
              Team
            </label>

            <div className="w-full max-w-full md:max-w-[calc(100%_-_128px)] relative">
              {isTeam ? (
                <div className="w-full flex gap-2 cursor-not-allowed uppercase items-center justify-between px-2 py-[6px] border border-bitzy-v2-gray/100/25 bg-bitzy-v2-white/30 rounded-lg">
                  <div className="flex items-center gap-2">
                    <Image
                      src={
                        teamSelect.find((t) => t.name === team)?.img ||
                        "/images/bitzy.png"
                      }
                      alt="Bitzy"
                      width={20}
                      height={20}
                      className={clsx(
                        teamSelect.find((t) => t.name === team)?.img
                          ? "w-7 h-5"
                          : "w-6 h-6 ",
                        "shadow-lg rounded"
                      )}
                    />
                    <span className="font-medium text-bitzy-v2-white">
                      {team ? team : "-"}
                    </span>
                  </div>
                </div>
              ) : (
                <Dropdown
                  inline
                  arrowIcon={false}
                  placement="bottom"
                  theme={{
                    floating: {
                      base: "z-10 !-stop-1 !translate-x-0 !translate-y-11 divide-y divide-gray-100 shadow focus:outline-none !backdrop-blur !bg-bitzy-v2-black/80 border !border-bitzy-v2-gray/100/25 rounded-xl",
                      style: {},
                      target: "w-full",
                      item: {
                        container: "",
                        base: "flex w-full cursor-pointer items-center justify-start px-4 py-2 hover:!bg-bitzy-v2-gray/25 focus:!bg-bitzy-v2-gray/25 focus:outline-none",
                      },
                    },
                    inlineWrapper: "w-full flex items-center flex-1",
                  }}
                  label={
                    <div
                      className={clsx(
                        "w-full flex gap-2 cursor-pointer uppercase items-center justify-between px-2 py-[6px]",
                        "border border-bitzy-v2-gray/100/25 rounded-lg text-bitzy-v2-white placeholder:text-bitzy-v2-white/200 bg-bitzy-v2-white/25 focus:ring-0 focus:outline-none focus:border-bitzy-white/50 w-full h-9"
                      )}
                    >
                      <div className="flex items-center gap-2">
                        {team && (
                          <Image
                            src={
                              teamSelect.find((t) => t.name === team)?.img ||
                              "/images/bitzy.png"
                            }
                            alt="Bitzy"
                            width={20}
                            height={20}
                            className={clsx(
                              team ? "w-7 h-5 shadow-lg rounded" : "w-6 h-6"
                            )}
                          />
                        )}

                        <span className="font-medium text-bitzy-glass-white">
                          {team ? team : "Select Team"}
                        </span>
                      </div>
                      <FiChevronDown className="w-4 h-4 text-sm text-bitzy-glass-white" />
                    </div>
                  }
                >
                  {teamSelect.map((t) => {
                    return (
                      <>
                        <DropdownItem className="!p-0" key={t.name}>
                          <div
                            className="w-full flex items-center relative ps-5 pe-5 py-2 cursor-pointer uppercase gap-2"
                            onClick={() =>
                              handleTeamChange(t.name as TeamSelect)
                            }
                          >
                            <Image
                              src={t.img || "/images/bitzy.png"}
                              alt="Bitzy"
                              width={20}
                              height={20}
                              className={clsx("w-7 h-5 shadow-lg rounded")}
                            />
                            <span className="text-bitzy-glass-white cursor-pointer">
                              {t.name}
                            </span>
                            {team === t.name && (
                              <FaCheck className="w-3 h-3 absolute left-1 top-1/2 -mt-[6px] text-sm text-bitzy-glass-white" />
                            )}
                          </div>
                        </DropdownItem>
                      </>
                    );
                  })}
                </Dropdown>
              )}

              <span className="text-bitzy-white text-xs">
                *** Once the team is selected, it cannot be modified later. ***
              </span>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-3 md:gap-7">
            <label className="w-full max-w-full md:max-w-28 font-poppins text-bitzy-white">
              Bio
            </label>

            <div className="w-full max-w-full md:max-w-[calc(100%_-_128px)]">
              <textarea
                rows={4}
                value={bio}
                onChange={handleBioChange}
                className="border border-bitzy-v2-gray/100/25 rounded-lg text-bitzy-v2-white placeholder:text-bitzy-v2-white/200 p-2 bg-bitzy-v2-white/25 focus:ring-0 focus:outline-none focus:border-bitzy-white/50 w-full"
              />
            </div>
          </div>
        </div>

        {errorMessage && (
          <motion.div
            variants={container}
            initial="hidden"
            animate="show"
            className="text-center text-bitzy-v2-red/100 select-none border border-bitzy-v2-red/100 rounded-lg p-2"
          >
            {errorMessage}
          </motion.div>
        )}

        <Button
          disabled={isSubmitting || !!errorMessage}
          onClick={handleSave}
          noShadow={true}
          size="medium"
          wide
          kind={"theme"}
        >
          {buttonText}
        </Button>
      </div>
    </>
  );
}
